/* Luna (8 okt 2026): Shop The Look. Lookkaarten (snippets/luna-look-kaart.liquid) en "Complete your look" in de
   winkelwagenlade (snippets/luna-look-lade.liquid). Per stuk een keuze per optie (kleur, maat); het script zoekt de
   variant, schakelt onmogelijke of uitverkochte combinaties uit, werkt prijs en totaal bij en zet de look in de
   winkelwagen met de verborgen eigenschap _look (naam van de look). Daarna ververst het de lade van het thema
   (cart-items.getCart(), die de lade ook opent); zonder lade gaat het naar /cart.
   Filters op de pagina: knoppen [data-filter], groepen [data-groep]. Voor later ingeladen blokken: LunaLook.init(el).
   Ronde 3 (9 okt): het stuk van de productpagina zelf ([data-huidig]) volgt kleur en maat van de keuze bovenaan
   (de verborgen radio's .luna-option-input van het code-blok "Custom Variant Picker"), ook als de klant die wijzigt;
   de kleur pas als de klant bovenaan een kleur kiest of binnenkwam op een variant (data-volg-kleur), anders de lookkleur;
   een compact stuk ("This dress") toont die keuze als tekst. Een stuk zonder variantgegevens verbergt de hele look.
   Ronde 4 (9 okt, iPhone): alle bedragen met het voorvoegsel van de markt (AU: A$); keuzelijsten die hun langste tekst
   niet kunnen tonen, gaan op een eigen regel (pasBreed); de terug-naar-boven-knop van het thema verdwijnt zolang hij
   over een knop van een look zou vallen.
   Ronde 5 (9 okt): het script verbergt nooit een look (dat beslist alleen Liquid). Ontbreken de variantgegevens van een
   stuk in de pagina, dan haalt het script ze op (/products/<handle>.js, nog 2 keer bij een fout); mislukt dat, of mislukt
   het toevoegen (429, netwerkfout, time-out; ook nog 2 keer), dan blijft de look staan en ziet de klant bij
   "Add the full look": "Something went wrong, please try again".
   Laatste ronde (10 okt): elke look-toevoeging krijgt naast _look ook _look_bron (zie bronVan).
   Polijstronde (10 okt): de kleur ligt vast per look (verborgen lijst); zichtbaar zijn alleen maat en hakhoogte. Het
   compacte stuk "This dress" toont "Colour: X" en volgt de kleur die de klant bovenaan kiest. Een maat staat nooit vooraf
   ingevuld: die komt alleen van ?variant= (Liquid) of van een maat die de klant bovenaan zelf kiest. Per stuk een
   doorgestreepte vergelijkingsprijs als die hoger is (het totaal telt alleen de prijzen). Op de pagina per groep 4 looks,
   de rest achter "Show all X looks" (ook geopend door een filter of een link naar zo'n look). */
(function () {
  'use strict';

  function geldFormaat(voorbeeld) {
    // voorbeeld = 1234567 centen geformatteerd door het thema, bv. "£12,345.67" of "$12.345,67"
    var m = String(voorbeeld || '').match(/(\d[\d.,\s]*\d)/);
    if (!m) return function (c) { return (c / 100).toFixed(2); };
    var getal = m[1], dec = getal.charAt(getal.length - 3), duizend = getal.charAt(getal.length - 7);
    var heeftDec = dec === '.' || dec === ',';
    if (duizend === dec || /\d/.test(duizend)) duizend = '';
    return function (centen) {
      var heel = Math.floor(Math.abs(centen) / 100).toString(), rest = ('0' + Math.abs(centen) % 100).slice(-2);
      heel = heel.replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
      return voorbeeld.replace(getal, heeftDec ? heel + dec + rest : heel);
    };
  }

  var FOUT = 'Something went wrong, please try again';

  function varianten(stuk) {
    if (!stuk._v) {
      try { stuk._v = JSON.parse(stuk.querySelector('[data-varianten]').textContent); } catch (e) { stuk._v = []; }
      if (!Array.isArray(stuk._v)) stuk._v = [];
    }
    return stuk._v;
  }

  function wacht(ms) { return new Promise(function (z) { setTimeout(z, ms); }); }


  // Laatste ronde (10 okt): waar de look werd toegevoegd, als verborgen eigenschap _look_bron (pagina, productpagina,
  // collectie, winkelwagen; homepage = de pagina, binnengekomen via een homepagekaart met ?bron=homepage).
  function bronVan(look) {
    var b = (look && look.dataset.lookBron) || 'pagina';
    if (b === 'pagina' && /[?&]bron=homepage(&|$)/.test(window.location.search)) b = 'homepage';
    return b;
  }

  function metHerhaling(doe, keer, pauze) {
    // doe() geeft een promise; bij een fout nog 'keer' keer proberen, met een korte pauze (die telkens iets langer wordt).
    return doe().catch(function (fout) {
      if (keer <= 0 || (fout && fout.definitief)) throw fout;
      return wacht(pauze).then(function () { return metHerhaling(doe, keer - 1, pauze * 2); });
    });
  }

  function haalJson(url) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var klok = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
    return fetch(url, { headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { clearTimeout(klok); if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); },
            function (e) { clearTimeout(klok); throw e; });
  }

  function laadVarianten(stuk) {
    // Alleen als de gegevens niet in de pagina staan (zou niet moeten gebeuren): ophalen, nog 2 keer bij een fout.
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var handle = stuk.dataset.handle;
    if (!handle) return Promise.reject(new Error('geen handle'));
    return metHerhaling(function () { return haalJson(root + 'products/' + handle + '.js'); }, 2, 600).then(function (p) {
      stuk._v = (p.variants || []).map(function (v) {
        return { id: v.id, o: v.options, a: v.available, p: v.price, img: v.featured_image ? v.featured_image.src : null };
      });
      if (!stuk._v.length) throw new Error('geen varianten');
    });
  }

  function kleurTekst(w) {
    // "wine red" -> "Wine Red", "Black 6cm" -> "Black" (woorden met een cijfer vallen weg), zoals in Liquid.
    return String(w).split(/\s+/).filter(function (x) { return x && !/\d/.test(x); })
      .map(function (x) { return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase(); }).join(' ');
  }

  function past(v, keuzes, behalve) {
    for (var i = 0; i < keuzes.length; i++) {
      if (i === behalve || keuzes[i] === null || keuzes[i] === '' || keuzes[i] === undefined) continue;
      if (v.o[i] !== keuzes[i]) return false;
    }
    return true;
  }

  function werkStukBij(stuk, geld, gewijzigd) {
    var selects = stuk.querySelectorAll('[data-optie]');
    var lijst = varianten(stuk);
    var keuzes = [];
    selects.forEach(function (s) { keuzes[Number(s.dataset.optie)] = s.value; });
    // Opties uitschakelen die met de andere keuzes geen beschikbare variant geven. De keuze die de klant net maakte
    // (gewijzigd) blijft staan; een andere keuze die er niet meer bij past, wordt leeggemaakt. Twee rondes.
    for (var ronde = 0; ronde < 2; ronde++) {
      selects.forEach(function (s) {
        var i = Number(s.dataset.optie);
        Array.prototype.forEach.call(s.options, function (opt) {
          if (!opt.value) return;
          var kan = lijst.some(function (v) { return v.a && v.o[i] === opt.value && past(v, keuzes, i); });
          opt.disabled = !kan;
          if (!kan && s.value === opt.value && i !== gewijzigd && s.querySelector('option[value=""]')) {
            s.value = ''; keuzes[i] = '';
          }
        });
      });
    }
    var compleet = keuzes.every(function (k) { return k; });
    var gekozen = null;
    if (!selects.length) {
      gekozen = lijst[0] || null;
    } else if (compleet) {
      gekozen = lijst.filter(function (v) { return v.a && past(v, keuzes, -1); })[0] || null;
    }
    var titel = stuk.querySelector('.llk__titel[data-kleur-optie]');
    var ki = titel ? Number(titel.dataset.kleurOptie) : -1;
    if (titel && ki >= 0 && titel.dataset.basis && keuzes[ki]) {
      // Ronde 2: korte naam met de gekozen kleur vooraan; woorden met een cijfer ("6cm") vallen weg, zoals in Liquid.
      var kleur = keuzes[ki].split(/\s+/).filter(function (w) { return w && !/\d/.test(w); })
        .map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join(' ');
      titel.textContent = (kleur ? kleur + ' ' : '') + titel.dataset.basis;
    }
    var dit = stuk.querySelector('[data-dit-waarden]');
    var kleurSel = stuk.querySelector('select[data-soort="kleur"]');
    if (dit && kleurSel && kleurSel.value) dit.textContent = 'Colour: ' + kleurTekst(kleurSel.value);
    var veld = stuk.querySelector('[data-variant-id]');
    if (selects.length) veld.value = gekozen ? gekozen.id : '';
    var toon = gekozen || lijst.filter(function (v) { return v.a && past(v, keuzes, -1); })[0] || lijst[0];
    if (toon) {
      stuk._prijs = toon.p;
      var prijs = stuk.querySelector('[data-stukprijs]');
      if (prijs) prijs.textContent = geld(toon.p);
      var verg = stuk.querySelector('[data-stukvergelijk]'), blok = stuk.querySelector('[data-prijsblok]');
      if (verg) {
        var sale = toon.c && toon.c > toon.p;
        verg.textContent = sale ? geld(toon.c) : ''; verg.hidden = !sale;
        if (blok) blok.classList.toggle('sale', !!sale);
      }
      var foto = stuk.querySelector('.llk__stukfoto');
      if (foto && toon.img && gewijzigd >= 0 && foto.dataset.img !== toon.img) {
        foto.removeAttribute('srcset'); foto.src = toon.img; foto.dataset.img = toon.img;
      }
    }
  }

  function werkTotaalBij(look, geld) {
    var was = look.querySelector('[data-totaal]'), na = look.querySelector('[data-na]');
    if (!was && !na) return;
    var stukken = look.querySelectorAll('[data-stuk]');
    // Zonder gegevens van een stuk geen nieuw totaal: dan blijven de bedragen van Liquid staan.
    if (Array.prototype.some.call(stukken, function (s) { return s._prijs === undefined; })) return;
    var totaal = 0, minKrijg = 0, n = 0;
    stukken.forEach(function (s) {
      var p = s._prijs || 0; totaal += p; n++;
      // Complete the look (AU): korting op het goedkoopste stuk uit Shoes & Bags, zoals de winkelwagen doet; afgekapt op
      // hele centen, net als de winkelwagen (gemeten 8 okt: 25% van $99.95 = $24.98).
      if (s.dataset.krijg === 'true' && (!minKrijg || p < minKrijg)) minKrijg = p;
    });
    var d = look.dataset, korting = 0;
    if (d.aanbod === 'complete_the_look') {
      if (minKrijg > 0 && n > 1) korting = Math.floor(minKrijg * Number(d.ctl) / 100);
    } else {
      // UK: per regel afgekapt, zoals de winkelwagen (gemeten 10 okt: 30% van £39.95 = £11.98).
      var pct = n >= 4 ? Number(d.t4) : n === 3 ? Number(d.t3) : n === 2 ? Number(d.t2) : 0;
      stukken.forEach(function (s) { korting += Math.floor((s._prijs || 0) * pct / 100); });
    }
    if (was) was.textContent = geld(totaal);
    if (na && korting > 0) na.textContent = geld(totaal - korting);
    var bespaar = look.querySelector('[data-bespaar]');
    if (bespaar) {
      bespaar.textContent = geld(korting);
      bespaar.parentNode.hidden = korting <= 0;
    }
  }

  function lade(root) {
    // De lade van het thema (Broadcast): <cart-items> haalt de regels opnieuw op en opent de lade.
    var ci = document.querySelector('cart-drawer cart-items') || document.querySelector('cart-items');
    if (ci && typeof ci.getCart === 'function') { ci.getCart(); return; }
    window.location.href = root + 'cart';
  }

  function keuzeBoven(pid, stuk) {
    // Kleur en maat bovenaan de productpagina: de aangevinkte radio's van de picker, anders de variant in input[name=id].
    var picker = document.querySelector('.luna-variant-picker[data-product-id="' + pid + '"]');
    var uit = [];
    if (picker) {
      picker.querySelectorAll('.luna-option-input:checked').forEach(function (r) { uit[Number(r.dataset.optionIndex)] = r.value; });
      if (uit.length) return uit;
    }
    var id = document.querySelector('.form__wrapper input[name="id"]');
    var v = id && varianten(stuk).filter(function (x) { return String(x.id) === id.value; })[0];
    return v ? v.o.slice() : null;
  }

  function volgBoven(look, geld, radio) {
    var veranderd = false;
    look.querySelectorAll('[data-huidig]').forEach(function (stuk) {
      var boven = keuzeBoven(stuk.dataset.huidig, stuk);
      if (!boven) return;
      var compact = stuk.classList.contains('llk__stuk--compact');
      if (radio) {
        // De klant kiest bovenaan zelf: een kleur volgt alleen het compacte stuk ("This dress"; elders ligt de kleur vast
        // per look), een maat of hakhoogte volgt elk stuk van dit product. Daarvoor: de kleur van de look, geen maat.
        var bij = stuk.querySelector('select[data-optie="' + radio.dataset.optionIndex + '"]');
        if (bij && bij.dataset.soort === 'kleur' && compact) stuk.dataset.volgKleur = 'true';
        if (bij && (bij.dataset.soort === 'maat' || bij.dataset.soort === 'hak') && !bij.dataset.kleurhak) stuk.dataset.volgMaat = 'true';
      }
      stuk.querySelectorAll('select[data-optie]').forEach(function (s) {
        if (s.dataset.kleurhak) return;
        if (s.dataset.soort === 'kleur' && (stuk.dataset.volgKleur !== 'true' || !compact)) return;
        if ((s.dataset.soort === 'maat' || s.dataset.soort === 'hak') && stuk.dataset.volgMaat !== 'true') return;
        var w = boven[Number(s.dataset.optie)];
        if (w && s.value !== w && s.querySelector('option[value="' + (window.CSS && CSS.escape ? CSS.escape(w) : w) + '"]')) {
          s.value = w; s.classList.remove('llk__select--fout'); s.removeAttribute('aria-invalid');
        }
      });
      // 99 = geen keuze die voorrang heeft, maar de stukfoto mag wel mee met de kleur.
      werkStukBij(stuk, geld, 99); veranderd = true;
    });
    if (veranderd) werkTotaalBij(look, geld);
  }

  var meetCanvas;
  function tekstBreedte(tekst, font) {
    meetCanvas = meetCanvas || document.createElement('canvas');
    var ctx = meetCanvas.getContext('2d'); ctx.font = font;
    return ctx.measureText(tekst).width;
  }

  function pastTekst(selects) {
    return selects.every(function (s) {
      var cs = getComputedStyle(s);
      var ruimte = s.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight) - 2;
      var font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      return Array.prototype.every.call(s.options, function (o) { return tekstBreedte(o.textContent.trim(), font) <= ruimte; });
    });
  }

  function pasBreed(stuk) {
    // Polijstronde: maat en hakhoogte staan altijd naast elkaar als ze er allebei zijn (één lijst = volle breedte). Drie
    // stappen, de eerste die past wint: (1) naast elkaar in de kolom naast de foto, (2) naast elkaar onder foto en naam
    // over de volle breedte van het stuk, (3) pas als ook dat niet past: onder elkaar.
    var keuzes = stuk.querySelector('.llk__keuzes');
    var info = stuk.querySelector('.llk__info');
    var selects = Array.prototype.filter.call(stuk.querySelectorAll('select.llk__select'), function (s) { return !s.hidden; });
    if (!keuzes || keuzes.hidden || !selects.length || !stuk.offsetWidth) return;
    var zet = function (breed) { selects.forEach(function (s) { s.classList.toggle('llk__select--breed', breed); s.style.flex = ''; }); };
    // Naast elkaar met een breedte naar de inhoud: "Size" heeft minder nodig dan "10cm heel" (op 320 px past 50/50 niet,
    // naar inhoud wel).
    var opInhoud = function () {
      selects.forEach(function (s) {
        var cs = getComputedStyle(s), font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
        var langste = Math.max.apply(null, Array.prototype.map.call(s.options, function (o) { return tekstBreedte(o.textContent.trim(), font); }));
        s.classList.remove('llk__select--breed');
        s.style.flex = '1 1 ' + Math.ceil(langste + parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + 6) + 'px';
      });
    };
    var opEenRegel = function () { return selects.every(function (s) { return Math.abs(s.offsetTop - selects[0].offsetTop) < 2; }); };
    var probeer = function () {
      zet(false); if (pastTekst(selects)) return true;
      if (selects.length < 2) return false;
      opInhoud(); return pastTekst(selects) && opEenRegel();   // flex-wrap mag ze niet stiekem onder elkaar zetten
    };
    if (info && keuzes.parentNode !== info) { info.appendChild(keuzes); stuk.classList.remove('llk__stuk--onder'); }
    if (probeer()) return;
    if (info) {
      stuk.insertBefore(keuzes, info.nextSibling); stuk.classList.add('llk__stuk--onder');
      if (probeer()) return;
    }
    zet(true);
  }

  function pasAlleBreed() {
    document.querySelectorAll('[data-look] [data-stuk]').forEach(pasBreed);
  }

  function knopOnderTop() {
    // De terug-naar-boven-knop van het thema (rechtsonder, vast) mag niet over een knop van een look vallen.
    var top = document.querySelector('.btn--scroll-top');
    if (!top) return;
    var h = window.innerHeight, w = window.innerWidth;
    var zone = { l: w - 72, t: h - 72, r: w, b: h };
    var raak = Array.prototype.some.call(document.querySelectorAll('.llk__knop, .llk__los summary, .llk__select'), function (k) {
      var r = k.getBoundingClientRect();
      return r.width && r.right > zone.l && r.left < zone.r && r.bottom > zone.t && r.top < zone.b;
    });
    document.documentElement.classList.toggle('llk-geen-top', raak);
  }

  function initLook(look) {
    if (look._klaar) return; look._klaar = true;
    var geldKaal = geldFormaat(look.dataset.geld), voor = look.dataset.geldVoor || '';
    var geld = function (c) { return voor + geldKaal(c); };
    look.querySelectorAll('[data-stuk]').forEach(function (stuk) {
      if (!varianten(stuk).length) {
        // Gegevens ontbreken: de look blijft staan; ophalen op de achtergrond.
        stuk._laden = laadVarianten(stuk).then(function () {
          stuk._fout = false; werkStukBij(stuk, geld, -1); werkTotaalBij(look, geld);
        }, function () { stuk._fout = true; });
      }
      werkStukBij(stuk, geld, -1); pasBreed(stuk);
    });
    werkTotaalBij(look, geld);
    // Mega-ronde: opnieuw meten zodra de kaart van maat verandert (css later geladen, lettertype, draaien, filter):
    // anders bleven lijsten op 320 px naast elkaar staan met afgekapte tekst.
    if (window.ResizeObserver) {
      var wachtMaat = null;
      new ResizeObserver(function () {
        if (wachtMaat) return;
        wachtMaat = requestAnimationFrame(function () { wachtMaat = null; look.querySelectorAll('[data-stuk]').forEach(pasBreed); });
      }).observe(look);
    }
    if (look.querySelector('[data-huidig]')) {
      volgBoven(look, geld);
      document.addEventListener('change', function (e) {
        if (e.target && e.target.classList && e.target.classList.contains('luna-option-input')) volgBoven(look, geld, e.target);
      });
    }
    look.addEventListener('change', function (e) {
      var stuk = e.target.closest('[data-stuk]');
      if (!stuk) return;
      var sel = e.target.closest('[data-optie]');
      if (sel) { sel.classList.remove('llk__select--fout'); sel.removeAttribute('aria-invalid'); }
      werkStukBij(stuk, geld, sel ? Number(sel.dataset.optie) : -1); werkTotaalBij(look, geld);
      var melding = look.querySelector('[data-look-melding]'); if (melding) melding.textContent = '';
    });
    look.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-look-add]');
      if (!knop) return;
      var melding = look.querySelector('[data-look-melding]');
      var zonderGegevens = Array.prototype.some.call(look.querySelectorAll('[data-stuk]'), function (st) { return !varianten(st).length; });
      if (zonderGegevens) {
        // Ronde 5: de gegevens van een stuk konden niet worden geladen. Niets verbergen, alleen melden.
        melding.textContent = FOUT;
        return;
      }
      var items = [], leeg = [];
      look.querySelectorAll('[data-stuk]').forEach(function (stuk) {
        var id = stuk.querySelector('[data-variant-id]').value;
        if (!id) {
          var open = Array.prototype.filter.call(stuk.querySelectorAll('select[data-optie]'), function (s) { return !s.hidden && !s.value; });
          open.forEach(function (s) { s.classList.add('llk__select--fout'); s.setAttribute('aria-invalid', 'true'); leeg.push(s); });
          // Alles gekozen maar die combinatie is niet te koop (bv. de kleur van bovenaan in deze maat)
          if (!open.length) leeg.push({ dataset: { soort: 'niet' }, focus: function () {} });
          return;
        }
        items.push({ id: Number(id), quantity: 1, properties: { _look: look.dataset.lookNaam, _look_bron: bronVan(look) } });
      });
      if (leeg.length || items.length < look.querySelectorAll('[data-stuk]').length) {
        // Ronde 2: rode rand om de lege lijst en een korte melding; niets toevoegen.
        var maat = leeg.some(function (s) { return s.dataset.soort === 'maat'; });
        var soort = leeg.length ? leeg[0].dataset.soort : 'maat';
        melding.textContent = maat ? 'Please choose a size' : soort === 'hak' ? 'Please choose a heel height' : soort === 'niet' ? 'Please choose another size' : 'Please choose an option';
        if (leeg[0]) leeg[0].focus();
        return;
      }
      if (!items.length) return;
      var tekst = knop.textContent;
      knop.disabled = true; melding.textContent = '';
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      metHerhaling(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (r.ok) return r;
          // 429 (te veel aanvragen) of een serverfout: nog eens proberen. 422 (bv. niet meer leverbaar): Shopify's uitleg tonen.
          if (r.status === 429 || r.status >= 500) throw new Error(FOUT);
          return r.json().catch(function () { return {}; }).then(function (j) {
            var f = new Error(j.description || j.message || FOUT); f.definitief = true; throw f;
          });
        }, function () { throw new Error(FOUT); });
      }, 2, 700).then(function (r) {
        knop.textContent = 'Added';
        setTimeout(function () { knop.textContent = tekst; knop.disabled = false; }, 2500);
        lade(root);
      }).catch(function (err) {
        knop.disabled = false; knop.textContent = tekst; melding.textContent = err.message;
      });
    });
  }

  function openGroep(g, open) {
    g.classList.toggle('is-open', open);
    var knop = g.querySelector('[data-toon-alle]');
    if (knop) { knop.setAttribute('aria-expanded', open ? 'true' : 'false'); knop.parentNode.hidden = open; }
  }

  function initFilters(sectie) {
    var knoppen = sectie.querySelectorAll('[data-filter]');
    knoppen.forEach(function (k) {
      k.addEventListener('click', function () {
        var waarde = k.dataset.filter;
        knoppen.forEach(function (x) { x.setAttribute('aria-pressed', x === k ? 'true' : 'false'); });
        sectie.querySelectorAll('[data-groep]').forEach(function (g) {
          g.hidden = waarde !== 'all' && g.dataset.groep !== waarde;
          // Een gekozen gelegenheid toont al haar looks; "All looks" weer 4 per groep.
          openGroep(g, waarde !== 'all' && !g.hidden);
        });
        pasAlleBreed();
      });
    });
    sectie.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-toon-alle]');
      if (!knop) return;
      openGroep(knop.closest('[data-groep]'), true); pasAlleBreed();
    });
    // Link naar een look die achter "Show all" staat (bv. vanaf de homepage): groep openen en de look in beeld brengen.
    var doel = location.hash && location.hash.length > 1 ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null;
    if (doel && sectie.contains(doel) && doel.classList.contains('llk--meer')) {
      openGroep(doel.closest('[data-groep]'), true);
      setTimeout(function () { doel.scrollIntoView({ block: 'start' }); }, 50);
    }
  }

  function initSchuif(rij) {
    // Ronde 2: rij die horizontaal schuift (collectiepagina's), met pijltjes; die staan uit als alles al zichtbaar is.
    var houder = rij.closest('[data-schuif-houder]');
    if (!houder) return;
    var vorige = houder.querySelector('[data-schuif-vorige]'), volgende = houder.querySelector('[data-schuif-volgende]');
    function stap() { var k = rij.querySelector('.llk'); return k ? k.getBoundingClientRect().width + 20 : rij.clientWidth; }
    function bij() {
      var kan = rij.scrollWidth > rij.clientWidth + 2;
      houder.classList.toggle('is-schuifbaar', kan);
      if (vorige) vorige.disabled = rij.scrollLeft <= 2;
      if (volgende) volgende.disabled = rij.scrollLeft + rij.clientWidth >= rij.scrollWidth - 2;
    }
    if (vorige) vorige.addEventListener('click', function () { rij.scrollBy({ left: -stap(), behavior: 'smooth' }); });
    if (volgende) volgende.addEventListener('click', function () { rij.scrollBy({ left: stap(), behavior: 'smooth' }); });
    rij.addEventListener('scroll', bij, { passive: true });
    window.addEventListener('resize', bij);
    bij();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-schuif]').forEach(function (r) { if (!r._klaar) { r._klaar = true; initSchuif(r); } });
    (root || document).querySelectorAll('[data-look]').forEach(initLook);
    (root || document).querySelectorAll('[data-look-filters]').forEach(function (s) {
      if (!s._klaar) { s._klaar = true; initFilters(s); }
    });
  }

  var wachtResize, wachtScroll;
  window.addEventListener('resize', function () { clearTimeout(wachtResize); wachtResize = setTimeout(function () { pasAlleBreed(); knopOnderTop(); }, 150); });
  window.addEventListener('scroll', function () { if (!wachtScroll) { wachtScroll = requestAnimationFrame(function () { wachtScroll = null; knopOnderTop(); }); } }, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(pasAlleBreed);
  window.addEventListener('load', function () { pasAlleBreed(); setTimeout(pasAlleBreed, 800); });

  window.LunaLook = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
